<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-13 10:11:38
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\CustomForm\newCustomForm.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-02 15:39:30
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_customForm_form_newTitle')"
    pad="0"
    widthClass="max-1000"
    :initData="customFormData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'application_type_name',
      'type_code',
      'application_type_desc',
      'flow_template_uuid',
      'color_code',
      'sequence',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-switch
                  color="primary"
                  class="ml-4"
                  v-model="customFormData.status"
                  :label="
                    customFormData.status
                      ? $t('label_essweb_customForm_form_activeLabel')
                      : ''
                  "
                ></v-switch>
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <inputTextFiledMultiLang
                  :bindData="customFormData.application_type_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      customFormData.application_type_name = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_customForm_form_customFormNameLabel')
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="
                    $t('label_essweb_customForm_form_customFormCodeLabel')
                  "
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="customFormData.type_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="customFormData.application_type_desc"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      customFormData.application_type_desc = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_customForm_form_customFormDescLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_customForm_form_customFormApprovalFlowLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="approvalFlows"
                  item-text="view_fields"
                  item-value="value_field"
                  single-line
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="customFormData.flow_template_uuid"
                  filled
                  :label="
                    $t(
                      'label_essweb_customForm_form_customFormApprovalFlowLabel'
                    )
                  "
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_customForm_form_colorLabel")
                }}</v-sheet>
                <SelectColor
                  :items="$Colors"
                  v-model="customFormData.color_code"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <numberInputTextFiled
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 15])
                  "
                  v-model="customFormData.sequence"
                  :label="$t('label_essweb_customForm_form_sequenceLabel')"
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_customForm_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  v-model="customFormData.remarks"
                  dense
                  counter="500"
                  single-line
                  filled
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-container fluid class="mrc-grey rounded-lg">
            <v-sheet
              class="transparent d-flex pa-0 my-3 align-center"
              v-for="(item, index) in NoticeList"
              :key="index"
            >
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-card
                  class="
                    white
                    d-flex
                    flex-row
                    justify-space-around
                    flex-grow-1
                    ml-3
                    pa-2
                    align-center
                  "
                  :elevation="hover ? 10 : 2"
                >
                  <div style="width: 20px">
                    <svg-icon
                      size="24"
                      :fill="'black'"
                      iconClass="LabeledColour"
                    />
                  </div>
                  <span class="ml-2">
                    {{
                      $getCommonLangValue(
                        item["application_type_notice_point_" + item.number]
                      )
                    }}
                  </span>
                  <v-spacer></v-spacer>
                  <div>
                    <v-btn
                      icon
                      x-small
                      class="ma-2"
                      @click="toEditNotice(item)"
                    >
                      <span class="material-icons-round">edit</span>
                    </v-btn>
                    <v-btn
                      icon
                      class="ma-2"
                      @click="onDeleteNotice(item.number)"
                    >
                      <span class="material-icons-round">delete</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-hover>
            </v-sheet>
          </v-container>
        </template>
        <template v-slot:content-3>
          <Tabler :headers="headers" :items="desserts" border :avPerPage="50">
            <template v-slot:item.sequence="{ item }">
              {{ item.sequence }}
            </template>
            <template v-slot:item.label="{ item }">
              {{ $getCommonLangValue(item.custom_field_name) }}
            </template>
            <template v-slot:item.type="{ item }">
              {{ $getCommonLangValue(item.custom_field_data_type_name) }}
            </template>
            <template v-slot:item.mandatory="{ item }">
              <span class="material-icons-round" v-if="Number(item.is_required)"
                >check</span
              >
              <span class="material-icons-round" v-else>close</span>
            </template>
            <template v-slot:item.action="{ item }">
              <div>
                <v-btn icon x-small class="ma-2" @click="toEditItem(item)">
                  <span class="material-icons-round">edit</span>
                </v-btn>
                <v-btn icon class="ma-2" @click="onDeleteItem(item.uuid)">
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </div>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider></v-divider>
                <v-btn
                  text
                  small
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="showNewItem = true"
                >
                  {{ $t("label_essweb_customForm_form_newItemLabel") }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="step == curStep && curStep != 0 ? true : false"
        :step="step == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <template v-slot:tools-main>
      <newNotice
        :show="showNewNotice"
        @close="
          showNewNotice = false;
          NoticePropertyData = null;
        "
        :PropertyData="NoticePropertyData"
        @onNew="onNewNotice"
      />
      <newItem
        :show="showNewItem"
        @close="showNewItem = false"
        @onNew="onNewItem"
      />
      <editItem
        :show="showEditItem"
        @close="
          showEditItem = false;
          curItemPropertyData = null;
        "
        @onEdit="onEditItem"
        :PropertyData="curItemPropertyData"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import newNotice from "@/Page/EssAdmin/CustomForm/CustomForm/components/newNotice";
import newItem from "@/Page/EssAdmin/CustomForm/CustomForm/components/newItem";
import editItem from "@/Page/EssAdmin/CustomForm/CustomForm/components/editItem";
export default {
  name: "newCustomForm",
  components: { newNotice, newItem, editItem },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
    approvalFlows() {
      return this.$getSelectTrans(this.approvalFlowsData, "view_fields");
    },
  },
  data() {
    return {
      step: 3,
      curStep: 1,
      isChanged: false,
      approvalFlowsData: [],
      NoticeList: [],
      stepper: [
        "label_essweb_customForm_form_tab_InfoLabel",
        "label_essweb_customForm_form_tab_TermsLabel",
        "label_essweb_customForm_form_tab_ItemsLabel",
      ],
      willClearNotice: null,
      showNewNotice: false,
      showEditItem: false,
      showNewItem: false,
      curItemPropertyData: null,
      NoticePropertyData: null,
      customFormData: {
        status: 1,
        application_type_name: "",
        type_code: "",
        application_type_desc: "",
        flow_template_uuid: "",
        color_code: "",
        sequence: 1,
        remarks: "",
        application_type_notice_point_1: "",
        application_type_notice_point_2: "",
        application_type_notice_point_3: "",
        application_type_notice_point_4: "",
        application_type_notice_point_5: "",
      },
      headers: [
        {
          text: "label_essweb_customForm_form_list_item_sequenceLabel",
          value: "sequence",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_labelLabel",
          value: "label",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_typeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_form_list_item_isMandatoryLabel",
          value: "mandatory",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          sortable: false,
          align: "end",
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.NoticeList = [];
    for (let i = 0; i < 5; i++) {
      let json = {};
      json["application_type_notice_point_" + (i + 1)] =
        this.$transCommonLangKey(this.$getCommonLangKey(this.companyLang));

      json["number"] = i + 1;
      this.NoticeList.push(json);
    }
    this.getApprovalFlows();
  },
  methods: {
    getApprovalFlows() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_workflow_template_select",
      }).then((res) => {
        that.approvalFlowsData = res.data;
      });
    },
    toEditNotice: function (obj) {
      this.NoticePropertyData = obj;
      this.showNewNotice = true;
    },
    onDeleteNotice: function (number) {
      const that = this;
      this.willClearNotice = number;
      this.$confirmDo(
        this.$t("label_essweb_customForm_form_tab_TermsLabel")
      ).then((res) => {
        if (res) that.toClearNotice();
      });
    },
    toClearNotice: function () {
      const that = this;
      this.NoticeList.map((item) => {
        if (item.number == that.willClearNotice) {
          item["application_type_notice_point_" + that.willClearNotice] =
            that.$transCommonLangKey(that.$getCommonLangKey(that.companyLang));
        }
      });
    },
    onNewNotice(notice, number) {
      this.NoticePropertyData = null;
      this.NoticeList.map((item) => {
        if (item.number == number) {
          item["application_type_notice_point_" + number] =
            this.$transCommonLangKey(notice);
        }
      });
      this.showNewNotice = false;
    },
    onNewItem(obj) {
      obj["uuid"] = Math.random() * 1000000000;
      obj["custom_field_name"] = this.$transCommonLangKey(
        obj["custom_field_name"]
      );
      obj["custom_field_placeholder"] = this.$transCommonLangKey(
        obj["custom_field_placeholder"]
      );
      this.showNewItem = false;
      this.desserts.push(obj);
    },
    toEditItem(obj) {
      this.curItemPropertyData = obj;
      this.showEditItem = true;
    },
    onDeleteItem(uuid) {
      const that = this;
      this.$confirmDo(
        this.$t("label_essweb_customForm_form_tab_ItemsLabel")
      ).then((res) => {
        if (res)
          that.desserts = that.desserts.filter((ele) => ele["uuid"] !== uuid);
      });
    },
    onEditItem(obj) {
      const that = this;
      obj["custom_field_name"] = this.$transCommonLangKey(
        obj["custom_field_name"]
      );
      obj["custom_field_placeholder"] = this.$transCommonLangKey(
        obj["custom_field_placeholder"]
      );
      this.desserts.some((item, index) => {
        if (item.uuid === obj.uuid) {
          that.desserts.splice(index, 1, obj);
          return true;
        }
      });
      this.showEditItem = false;
    },
    toNew() {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let ess_common_application_type_notice = {};
      this.NoticeList.forEach((item, index) => {
        ess_common_application_type_notice[
          "application_type_notice_point_" + item.number
        ] = item["application_type_notice_point_" + item.number];
      });
      let ess_common_application_type_custom_field = [];
      this.desserts.map((item) => {
        ess_common_application_type_custom_field.push({
          custom_field_name: item.custom_field_name,
          custom_field_placeholder: item.custom_field_placeholder,
          custom_field_data_type: item.custom_field_data_type,
          is_required: item.is_required ? 1 : 0,
          sequence: item.sequence,
          custom_field_data_layout: JSON.stringify(
            item.custom_field_data_layout
          ),
        });
      });
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/add/",
        data: {
          type_code: this.customFormData.type_code,
          application_type_name: this.$transCommonLangKey(
            this.customFormData.application_type_name
          ),
          application_type_desc: this.$transCommonLangKey(
            this.customFormData.application_type_desc
          ),
          status: this.customFormData.status ? 1 : 0,
          color_code: this.customFormData.color_code,
          sequence: this.customFormData.sequence,
          flow_template_uuid: this.customFormData.flow_template_uuid,
          ess_common_application_type_notice: [
            ess_common_application_type_notice,
          ],
          ess_common_application_type_custom_field:
            ess_common_application_type_custom_field,
          remarks: this.customFormData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    toNext() {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
  },
};
</script>